function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 27"
}, props), React.createElement("path", {
  d: "M10.5 13.086c.722 0 1.34-.255 1.855-.764a2.49 2.49 0 00.77-1.836c0-.715-.257-1.327-.77-1.837a2.543 2.543 0 00-1.855-.763c-.722 0-1.34.254-1.853.763a2.493 2.493 0 00-.772 1.837c0 .715.257 1.327.772 1.835.513.51 1.131.765 1.853.765zm0 13c-3.522-2.968-6.152-5.726-7.89-8.272C.87 15.269 0 12.913 0 10.746c0-3.25 1.056-5.84 3.167-7.768C5.277 1.05 7.722.086 10.5.086c2.778 0 5.222.964 7.333 2.892C19.944 4.907 21 7.496 21 10.746c0 2.167-.87 4.523-2.608 7.068-1.74 2.546-4.37 5.304-7.892 8.272z",
  fill: "#787777"
})));